// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class PortfolioModelRequest extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_PORTFOLIO_MODEL_REQUEST_MESSAGE, fieldSet);
    }
}
